import axios from "../lib/axios";

export const createTemplate = async (payload) => {
  try {
    const response = await axios.post(`/email-templates/create`, payload);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to create message"
    );
  }
};

export const getTemplate = async () => {
  try {
    const response = await axios.get(`/email-templates`);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to create message"
    );
  }
};


export const updateTemplate = async (id, payload) => {
  try {
    const response = await axios.put(`/email-templates/${id}`, payload);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Failed to update template");
  }
};

export const deleteTemplate = async (id) => {
  try {
    const response = await axios.delete(`/email-templates/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Failed to delete template");
  }
};